"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.propertyNeedsToPublish = void 0;
const hasUnpublishedChanges = (latestVersion, publishedVersion) => publishedVersion ? latestVersion > publishedVersion : true;
const propertyNeedsToPublish = (property) => {
    var _a, _b, _c, _d;
    return [
        property,
        ...((_a = property.bathrooms) !== null && _a !== void 0 ? _a : []),
        ...((_b = property.beds) !== null && _b !== void 0 ? _b : []),
        ...((_c = property.amenities) !== null && _c !== void 0 ? _c : []),
        ...((_d = property.restrictions) !== null && _d !== void 0 ? _d : [])
    ].some((t) => hasUnpublishedChanges(t.latest_version, t.published_version));
};
exports.propertyNeedsToPublish = propertyNeedsToPublish;
//# sourceMappingURL=util.js.map